import { Button, Icon } from 'antd';
import React, { ReactElement } from 'react';
import FormModal from '../FormModal/FormModal';
import { CenteredIcon } from '../../components/Table/CenteredIcon';

interface EditProps {
  title: string;
  crudForm: JSX.Element;
  showButtonText: boolean;
}

class CrudForm extends React.Component<EditProps> {
  public formRef;
  public state = { visible: false };
  public showModal = () => {
    this.setState({
      visible: true
    });
  };
  public handleOk = async (e) => {
    const validated = await this.validateForm();
    if (!validated) {
      return;
    }

    this.setState({ visible: false });
    this.formRef.performAction(this.getDirtyFields());
  };
  public handleCancel = (e) => {
    this.setState({ visible: false });
  };
  public setFormRef = (formRef) => {
    this.formRef = formRef;
  };
  private form: ReactElement<any>;
  private addProperties = (element: ReactElement<any>, props: {}) => {
    return React.cloneElement(element as ReactElement<any>, props);
  };
  private validateForm = async () => {
    let validated = false;

    await this.formRef.props.form.validateFields((errors, values) => {
      validated = !errors;
    });

    return validated;
  };
  private getDirtyFields = () => {
    const form = this.formRef.props.form;
    const fields = Object.keys(form.getFieldsValue());
    const dirty: string[] = [];

    for (const field of fields) {
      if (form.isFieldTouched(field)) {
        dirty.push(field);
      }
    }

    return dirty;
  };

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.form = this.addProperties(this.props.crudForm, { wrappedComponentRef: this.setFormRef });
  }

  render() {
    const { title } = this.props;
    const { visible } = this.state;
    const modalProps = {
      title,
      visible,
      handleCancel: this.handleCancel,
      handleOk: this.handleOk,
      showModal: this.showModal
    };

    return (
      <>
        <Button type='primary' onClick={this.showModal} htmlType={'button'}>
          {this.props.showButtonText ? (
            <span>
              <Icon type={'edit'} /> {this.props.title}
            </span>
          ) : (
            <span>
              <CenteredIcon icon={'edit'} iconSize={'16px'} />
            </span>
          )}
        </Button>
        <FormModal {...modalProps}>{this.form}</FormModal>
      </>
    );
  }
}

export default CrudForm;
